import {
  Box,
  Card,
  Flex,
  Grid,
  HStack,
  Skeleton,
  SkeletonCircle,
  VStack,
} from "@chakra-ui/react";

const skeletonProps = {
  bg: "#DAE9FF",
  borderRadius: "md",
};

const cardProps = {
  bg: "white",
  border: "none",
  borderWidth: 0,
  boxShadow: "sm",
  borderRadius: "2xl",
};

const StatCardSkeleton = () => (
  <Card.Root {...cardProps}>
    <Card.Body>
      <Flex
        justify="space-between"
        align="center"
      >
        <Box flex={1}>
          <Skeleton
            {...skeletonProps}
            h="12px"
            w="120px"
            mb={3}
          />

          <Skeleton
            {...skeletonProps}
            h="30px"
            w="90px"
            mb={3}
          />

          <Skeleton
            {...skeletonProps}
            h="10px"
            w="140px"
          />
        </Box>

        <SkeletonCircle
          bg="#DAE9FF"
          size="12"
        />
      </Flex>
    </Card.Body>
  </Card.Root>
);

const TableSkeleton = () => (
  <Card.Root {...cardProps}>
    <Card.Body
      p={{
        base: 4,
        md: 6,
      }}
    >
      {/* Header */}

      <Flex
        justify="space-between"
        align={{
          base: "flex-start",
          md: "center",
        }}
        direction={{
          base: "column",
          md: "row",
        }}
        gap={{
          base: 3,
          md: 0,
        }}
        mb={6}
      >
        <Skeleton
          {...skeletonProps}
          h="24px"
          w={{
            base: "180px",
            md: "220px",
          }}
        />

        <Skeleton
          {...skeletonProps}
          h="40px"
          w={{
            base: "100%",
            md: "200px",
          }}
        />
      </Flex>

      {/* Desktop Header */}

      <HStack
        display={{
          base: "none",
          md: "flex",
        }}
        gap={5}
        mb={5}
      >
        {Array.from({
          length: 6,
        }).map((_, i) => (
          <Skeleton
            key={i}
            {...skeletonProps}
            h="12px"
            flex={1}
          />
        ))}
      </HStack>

      {/* Rows */}

      <VStack
        gap={4}
        align="stretch"
      >
        {Array.from({
          length: 8,
        }).map((_, row) => (
          <Flex
            key={row}
            direction={{
              base: "column",
              md: "row",
            }}
            justify="space-between"
            align={{
              base: "flex-start",
              md: "center",
            }}
            gap={{
              base: 4,
              md: 0,
            }}
            py={3}
          >
            <HStack
              flex={2}
              w={{
                base: "100%",
                md: "auto",
              }}
            >
              <SkeletonCircle
                bg="#DAE9FF"
                size="10"
              />

              <Box flex={1}>
                <Skeleton
                  {...skeletonProps}
                  h="12px"
                  w="150px"
                  mb={2}
                />

                <Skeleton
                  {...skeletonProps}
                  h="10px"
                  w="100px"
                />
              </Box>
            </HStack>

            <Flex
              w={{
                base: "100%",
                md: "auto",
              }}
              justify={{
                base: "space-between",
                md: "flex-end",
              }}
              align="center"
              gap={4}
              wrap="wrap"
            >
              <Skeleton
                {...skeletonProps}
                h="12px"
                w="90px"
              />

              <Skeleton
                {...skeletonProps}
                h="12px"
                w="120px"
              />

              <Skeleton
                {...skeletonProps}
                h="28px"
                w="90px"
                borderRadius="full"
              />

              <Skeleton
                {...skeletonProps}
                h="34px"
                w="34px"
                borderRadius="full"
              />
            </Flex>
          </Flex>
        ))}
      </VStack>
    </Card.Body>
  </Card.Root>
);

export default function CommissionHistorySkeleton() {
  return (
    <>
      {/* Header */}

      <Box
        mb={{
          base: 6,
          md: 8,
        }}
      >
        <Skeleton
          {...skeletonProps}
          h="36px"
          w={{
            base: "220px",
            md: "320px",
          }}
          mb={3}
        />

        <Skeleton
          {...skeletonProps}
          h="16px"
          w={{
            base: "100%",
            md: "420px",
          }}
          mb={5}
        />

        <Skeleton
          {...skeletonProps}
          h="42px"
          w={{
            base: "150px",
            md: "180px",
          }}
        />
      </Box>

      {/* Stats */}

      <Grid
        templateColumns={{
          base: "1fr",
          sm: "repeat(2, 1fr)",
          xl: "repeat(4, 1fr)",
        }}
        gap={{
          base: 4,
          md: 6,
        }}
        mb={{
          base: 6,
          md: 8,
        }}
      >
        {Array.from({
          length: 4,
        }).map((_, i) => (
          <StatCardSkeleton key={i} />
        ))}
      </Grid>

      {/* Table */}

      <TableSkeleton />
    </>
  );
}